import { createContext, useReducer } from 'react';

export const initUserState = { 
    userName: null,
    companyType: null,
    functions: [], // 儲存功能清單
    editableFlags: {}, // 儲存各功能的可編輯狀態
    tabPermissions: {}, // 新增：儲存各功能的頁籤權限
    userRoles: null, // 新增：儲存用戶角色序號（單一字串）
    reflashFlag: false, // 新增：儲存是否需要重新加載功能清單
};

export function userReducer(state, action) {
  switch (action.type) {
    case "CHANGE_NAME":
      return { ...state, userName: action.payload };
    case "COMPANY_TYPE":
      return { ...state, companyType: action.payload };
    case "CURRENT_FUNCID":
      return { ...state, funcId: action.payload };
    case "CURRENT_PARENT_FUNCID":
      return { ...state, parentFuncId: action.payload };
    case "IS_ADMIN_INFO":
      return {
        ...state,
        isAdmin: action.payload.isAdmin,
        effectiveType: action.payload.effectiveType,
        companySeq: action.payload.companySeq,
      };
    case "COM_CONTRACT_DATA":
      return { ...state, companiesContractData: action.payload.companiesContractData };
    case "CLEAR_INFO":
      return { ...initUserState };
    case "DONT_SHOW_AGAIN":
      return { ...state, dontShowAgain: action.payload.dontShowAgain };
    case "SET_FUNCTIONS":
      return {
        ...state,
        functions: action.payload.functions,
        editableFlags: action.payload.editableFlags,
        tabPermissions: action.payload.tabPermissions,
      };
    case "SET_USER_ROLES":
      return { ...state, userRoles: action.payload.userRoles };
    case "REFLASH_FLAG":
      return { ...state, reflashFlag: action.payload.reflashFlag };
    case "APPROVE_FLAG":
      return { ...state, approveFlag: action.payload.approveFlag };
    default:
      return state;
  }
}

export const AcctContext = createContext();